import {
    URL_DOMAIN,
    // URL_DOMAIN_MARKET,
    getJSON,
    // URL_P2,
    requestOptionsGet,
    requestOptionsPost,
    requestOptionsPut,
    requestOptionsDelete
  } from "../globals";
  
  // const URL_FRANCHISES = URL_DOMAIN + URL_P2[0];
  
  // const supervisorId = localStorage.getItem("fk_supervisor");
  
  const organizationId = localStorage.getItem("fk_organization")
  /**
   * Franchises
   * @returns    
   */

  const postScheduleProductAvailability = async (formData) => {
    requestOptionsPost.body = formData;
    return fetch(URL_DOMAIN  + "product-availability-schedule/create-availability-schedule", requestOptionsPost).then(
      getJSON
    );
  };

  const getProductAvailabilitySchedule = async () => {
    return fetch(
      URL_DOMAIN + "product-availability-schedule/get-availability-schedules",
      requestOptionsGet
    ).then(getJSON);
  };

  const putScheduleProductAvailability = async (formData) => {
    requestOptionsPut.body = formData;
    return fetch(URL_DOMAIN + "product-availability-schedule/edit-availability-schedule", requestOptionsPut).then(
      getJSON
    );
  };

  const deleteScheduleProductAvailability = async (formData) => {
    requestOptionsPost.body = formData;
    return fetch(URL_DOMAIN + "product-availability-schedule/delete-availability-schedule", requestOptionsPost).then(
      getJSON
    );
  };
    
  export { postScheduleProductAvailability, getProductAvailabilitySchedule, putScheduleProductAvailability, deleteScheduleProductAvailability };